import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouter,
} from 'skybolt-ui';

import All from './All';
import Agency from './Agency';

export default props => {
  const {match:{path, url}} = useRouter();
  return (
    <Switch>
      <Route path={`${path}/all`} component={All}/>
      <Route path={`${path}/:agencyId`} component={Agency}/>
      <Redirect to={`${url}/all`}/>
    </Switch>
  );
};